/* eslint-disable sort-keys-fix/sort-keys-fix */
import { COMMUNITY_PAGES_PATH_PREFIX, type CommunityData } from "./types"

const S3_PREFIX = "https://media.werz.at/community-assets/pruyrvu/"

const pruyrvu: CommunityData = {
  code: "pruyrvu",
  inviteCode: "pruyrvu",
  name: "PRU Y RVU",
  thumbnail: "",
  favicon: "",
  url: `${COMMUNITY_PAGES_PATH_PREFIX}/pyr-239`,
  waitlist: true,
  socials: {},
  styles: {
    comingSoon: {
      bgColor: "#000000",
      hero: {
        desktop: `${S3_PREFIX}web-background.jpg`,
        mobile: `${S3_PREFIX}web-background-mobile.jpg`,
        style: "bg-[#222222]",
      },
      logo: {
        desktop: `https://media.werz.at/community-assets/pruyrvu/mobile-landing-logo.png`,
        mobile: `https://media.werz.at/community-assets/pruyrvu/mobile-landing-logo.png`,
        style: "h-[60px] sm:h-[88px]",
      },
      werzLogoColor: "#FFFFFF",
      title: "font-['NeutralFaceBold'] text-[28px] leading-[120%] text-[#d5d5d5]",
      text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-[#d5d5d5]",
      button:
        "font-['NeutralFaceBold'] text-[16px] leading-[120%] p-4 bg-[#ed1e25] text-[#000000] rounded-[4px] cursor-pointer w-fit",
      input: {
        base: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] w-[256px] px-4 h-[48px] bg-[#222222] text-[#d5d5d5]",
        border: "#444444",
        borderFocus: "#6d6d6d",
        borderError: "#FF0000",
        errorText: "text-[#FF0000]",
      },
      error: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#FF0000]",
      footerText:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8d8d8d]",
      skipButton:
        "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8d8d8d] cursor-pointer",
      modal: {
        container: "bg-[#222222] px-[40px] py-[48px]",
        title: "font-['NeutralFaceBold'] text-[24px] leading-[120%] text-[#d5d5d5] text-center",
        text: "font-['NeueHaasGroteskDisplayPro55Roman'] text-[14px] leading-[120%] text-[#8d8d8d] text-center",
        width: "w-[358px]",
        backdrop: "bg-black/50",
        otpInput:
          "!w-[40px] !h-[50px] rounded-[4px] text-[#d5d5d5] bg-[#000000] font-['NeueHaasGroteskDisplayPro55Roman'] text-[16px] leading-[120%] text-center",
        otpBorder: "#444444",
        otpBorderFocus: "#6d6d6d",
      },
    },
    global: {
      werzLogoColor: "#FFF",
      counterColor: "#FFF",
      logo: {
        src: `${S3_PREFIX}web-logo.png`,
        styles: "w-[94px] h-[88px]",
      },
      alternativeLogo: {
        src: `${S3_PREFIX}web-alternative-logo.png`,
        styles: "w-[94px] h-[88px]",
      },
      modalWindow: {
        container: "",
        title: "",
        subtitle: "",
      },
      bgColor: "#000000",
      asideBg: "#ed1e25",
      asideStyles: "border-r border-[#6d6d6d]",
      contentBg: "#000000",
      contentBoxShadow: "!border-0 !rounded-[24px] !overflow-hidden",
      bgDesktop: `${S3_PREFIX}web-background.jpg`,
      bgMobile: `${S3_PREFIX}web-background-mobile.jpg`,
      nonMemberBg: `${S3_PREFIX}web-background-non-member.png`,
      mainFont: "font-['NeueHaasGroteskDisplayPro55Roman']",
      primaryButton:
        "bg-[#ed1e25] border-2 border-[#ed1e25] rounded-[4px] px-[18px] py-[18px] !text-[#000000] font-['NeutralFaceBold'] !text-[16px] text-left",
    },
    navigation: {
      iconsColor: "#000000",
      sideBarSeparator: "border-r-[1px] border-black border-opacity-[15%]",
      separator: "border-[#000000]",
      item: "font-['NeutralFaceBold'] text-[14px] text-[#000000] text-left gap-x-[10px] text-opacity-50 text-center border-b border-[#000000] !pl-0 !py-3",
      itemSelected: " !text-opacity-100",
    },
    communityLanding: {
      container: "!bg-[#000000] !pb-8",
      titles: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%]",
      emptyOrLoadingState:
        "!mx-4 sm:!mx-8 text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      announcementsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#d5d5d5] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container: "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 gap-x-4",
          wrapper: "relative group",
          item: "w-fit",
        },
        item: {
          container:
            "min-w-[calc(100vw-48px)] sm:min-w-[256px] sm:max-w-[256px] overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:w-[256px] !aspect-square relative",
          media: "w-full !aspect-square object-cover",
          placeholderMedia: "w-full !aspect-square bg-gray-400",
          content: "flex flex-col py-4 bg-transparent",
          title: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      eventsV2: {
        sectionContainer: "py-4 sm:py-8 !m-0 space-y-0 !border-0 !border-b border-[#333333]",
        sectionTitle:
          "text-[#d5d5d5] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] pl-4 sm:pl-8 !mb-4 sm:mb-6",
        scrollMenu: {
          container:
            "content-start hide-scroll pl-4 sm:pl-8 pr-6 sm:pr-8 !h-full sm:!h-[128px] flex-row gap-6",
          wrapper: "relative group w-full",
          item: "w-fit",
        },
        item: {
          container:
            "flex sm:flex-row flex-col w-[calc(100vw-56px)] sm:!w-[428px] h-full overflow-hidden bg-[#ffffff00]",
          mediaContainer: "w-full sm:!w-[228px] sm:flex-shrink-0 relative",
          media: "w-full !aspect-video object-cover",
          placeholderMedia: "w-full !aspect-video bg-gray-400",
          content: "flex flex-col px-4 bg-transparent",
          title: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          subtitle:
            "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
          location:
            "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-1",
          date: "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mt-2",
        },
      },
      shop: {
        container: "py-4 sm:py-8 !pb-16 !m-0 space-y-0 !border-0 overflow-hidden",
        title: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['NeueHaasGroteskDisplayPro55Roman'] text-[18px] text-left leading-[120%]",
        customShopImageStyle: "",
        sectionTitle:
          "text-[#d5d5d5] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%] !mb-4 sm:mb-6",
      },
    },
    eventV2: {
      container: "flex flex-col !bg-[#000000] rounded-[24px] !pb-8",
      eventInfo: {
        container: "flex flex-col sm:flex-row gap-4 sm:gap-6 sm:p-8 p-4 border-b border-[#333333]",
        media: "sm:!w-[320px] !w-full !h-[180px] object-cover sm:mb-4 !border-0",
        title: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[26px] text-left leading-[110%]",
        subtitle:
          "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 mt-2",
        button:
          "bg-[#ed1e25] border-2 border-[#ed1e25] rounded-[4px] px-[18px] py-[18px] !w-fit mb-4 sm:mb-0 text-[#000000] font-['NeutralFaceBold'] !text-[16px] text-left",
        questions: "text-[15px] text-left leading-[120%]",
      },
      about: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 w-full",
      },
      location: {
        container: "flex flex-col gap-4 sm:p-8 p-4 border-b border-[#333333]",
        header: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-4 max-w-[652px] w-full",
        map: "w-full h-[206px] overflow-hidden border border-[#6d6d6d] gap-y-[10px]",
        mapPinColor: "#000000",
        mapStrokeColor: "#000000",
      },
      downloadWERZ: {
        container: "flex flex-col gap-4 sm:p-8 p-4",
        header: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%]",
        text: "text-[#d5d5d5] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%]",
      },
      tickets: {
        header:
          "text-[#d5d5d5] font-['NeutralFaceBold'] text-[22px] text-left leading-[110%] px-4 sm:px-8 pt-4 sm:pt-8 mb-2 sm:mb-4",
        outerContainer: "flex flex-col !bg-[#000000] !pb-8",
        innerContainer: "flex flex-col overflow-hidden px-4 sm:px-8",
        ticket: {
          container:
            "flex flex-row justify-between leading-auto !bg-[#ffffff00] border-b border-[#333333] py-4",
          mediaContainer: "!hidden",
          media: "!hidden",
          name: "text-[#d5d5d5] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%] mb-1",
          description:
            "text-[#8d8d8d] font-['NeueHaasGroteskDisplayPro55Roman'] text-[15px] text-left leading-[120%] mb-1 flex flex-row",
          price: "text-[#8d8d8d] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          quantity: "text-[#ed1e25] font-['NeutralFaceBold'] text-[14px] text-left",
          status: "text-[#8d8d8d] font-['NeutralFaceBold'] text-[15px] text-left leading-[110%]",
          counterContainer:
            "bg-[#000000] border border-[#ed1e25] rounded-[4px] px-[16px] py-[12px] gap-x-[16px] !w-fit !h-10",
          button:
            "bg-[#000000] border border-[#ed1e25] rounded-[4px] px-[16px] py-[12px] text-[#ed1e25] font-['NeutralFaceBold'] text-[14px] text-left !w-fit",
          plusMinusColor: "#ed1e25",
        },
      },
    },
  },
}

export default pruyrvu
